<template>
  <div>
    <div class="tw-flex tw-flex-start tw-justify-between">
      <p
        class="tw-mx-4 tw-block tw-text-eko-orange tw-mt-8 tw-font-bold tw-text-2xl"
      >
        Here are projects that you can offset
      </p>
    </div>
    <OffsetMeter />
    <div v-if="projects.length > 0" class="tw-flex tw-flex-wrap tw--mt-2">
      <div
        class="tw-w-full md:tw-w-1/4 tw-p-2"
        v-for="project in projects"
        :key="project._id"
      >
        <ProjectCard :project="project" />
      </div>
    </div>
    <div v-else>
      <p>No projects created yet</p>
    </div>
  </div>
</template>

<script>
import ProjectCard from "@/components/Offsetter/SingleProject.vue";
import OffsetMeter from "@/components/Offsetter/Offset/OffsetMeter.vue";
import axios from "axios";
export default {
  data() {
    return {
      data: {},
      projects: [],
      loading: false,
      errors: {},
      disabled: false,
      user: {},
      token: "",
    };
  },
  components: {
    ProjectCard,
    OffsetMeter,
  },
  mounted() {
    this.user = JSON.parse(localStorage.getItem("eko-carbon-user"));
    this.token = localStorage.getItem("eko-carbon-token");
    this.fetchProjects();
    this.getCarbon();
  },
  methods: {
    getCarbon() {
      axios
        .get(`${this.$baseUrl}/carbon/offset/get/${this.user._id}`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.token}`,
          },
        })
        .then((response) => {
          console.log(response.data);
          let carbon = response.data;
          if (carbon.size == 0) {
            this.$router.push("/offsetter/initial");
          }
        })
        .catch((error) => {
          self.loading = false;
          self.error = true;
          this.error = error;
          let err_msg = error.response.data ? error.response.data.message : "An error occured"
          self.$swal("Error!", err_msg, "error");
        });
    },
    fetchProjects() {
      axios
        .get(`${this.$baseUrl}/project/getAllLister`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.token}`,
          },
        })
        .then((response) => {
          console.log(response.data);
          this.projects = response.data.project;
          self.loading = false;
          self.success = true;
        })
        .catch((error) => {
          self.loading = false;
          self.error = true;
          this.error = error;
          let err_msg = error.response.data ? error.response.data.message : "An error occured"
          self.$swal("Error!", err_msg, "error");
        });
    },
  },
};
</script>

<style lang="css" scoped></style>
